// Stable admin left-menu tab keys + labels. Keys must match backend routers/auth.py ADMIN_MENU_KEYS.
export const ADMIN_MENU_ITEMS = [
  { key: "dashboard", label: "Dashboard" },
  { key: "clients", label: "Clientes" },
  { key: "technicians", label: "Técnicos" },
  { key: "schedules", label: "Programación" },
  { key: "reports", label: "Reportes" },
  { key: "documents", label: "Documentos" },
  { key: "floor-plans", label: "Mapas" },
  { key: "alerts", label: "Alertas" },
  { key: "executive-reports", label: "Informes Ejec." },
  { key: "transportes", label: "Transportes" },
  { key: "auditores", label: "Auditores" },
  { key: "insumos", label: "Insumos" },
  { key: "equipos", label: "Equipos" },
  { key: "asistencia", label: "Asistencia" },
  { key: "catalogo", label: "Catálogo Docs" },
  { key: "odoo", label: "Odoo (Mock)" },
  { key: "usuarios", label: "Usuarios" },
];

export const ALL_MENU_KEYS = ADMIN_MENU_ITEMS.map((i) => i.key);

export const ROLE_MENU_DEFAULTS = {
  admin: ALL_MENU_KEYS,
  operator: ["clients", "technicians", "documents", "floor-plans", "transportes", "catalogo"],
  auxiliar: ["clients", "documents", "floor-plans", "transportes", "catalogo"],
  auditor: [],
};

export const defaultMenuPermissions = (role) =>
  role === "admin" ? [...ALL_MENU_KEYS] : [...(ROLE_MENU_DEFAULTS[role] || [])];

// Route path for each menu key (must match the routes in App.js).
export const MENU_PATHS = {
  dashboard: "/admin",
  clients: "/admin/clients",
  technicians: "/admin/technicians",
  schedules: "/admin/schedules",
  reports: "/admin/reports",
  documents: "/admin/documents",
  "floor-plans": "/admin/floor-plans",
  alerts: "/admin/alerts",
  "executive-reports": "/admin/executive-reports",
  transportes: "/admin/transportes",
  auditores: "/admin/auditores",
  insumos: "/admin/insumos",
  equipos: "/admin/equipos",
  asistencia: "/admin/asistencia",
  catalogo: "/admin/catalogo",
  odoo: "/admin/odoo",
  usuarios: "/admin/usuarios",
};

// First admin-panel route the user is actually allowed to see (based on menu permissions).
export const firstAllowedAdminPath = (user) => {
  if (!user) return "/admin";
  if (user.role === "admin") return "/admin";
  const perms = Array.isArray(user.menu_permissions) ? user.menu_permissions : defaultMenuPermissions(user.role);
  for (const item of ADMIN_MENU_ITEMS) {
    if (perms.includes(item.key)) return MENU_PATHS[item.key];
  }
  return "/admin";
};
